import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ExtrasList from '../components/ExtrasList';

const ExtrasPage = () => {
  return (
    <div className="App">
      <Header />
      <main>
        <ExtrasList />
      </main>
      <Footer />
    </div>
  );
};

export default ExtrasPage;
